var _path, _mask, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85714 1H15.5714C16.4807 1 17.3528 1.42143 17.9958 2.17157C18.6388 2.92172 19 3.93913 19 5V17C19 17.2652 18.9097 17.5196 18.749 17.7071C18.5882 17.8946 18.3702 18 18.1429 18H4.42857C3.51926 18 2.64719 17.5786 2.00421 16.8284C1.36122 16.0783 1 15.0609 1 14V2C1 1.73478 1.09031 1.48043 1.25105 1.29289C1.4118 1.10536 1.62981 1 1.85714 1Z",
    stroke: "#F57078",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1450_5474",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 2,
    width: 10,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 18,
    y: 2,
    width: 10,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8L26 4V16L19 12"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H28C28 3.28706 27.6205 2.62802 27.0039 2.27018C26.3872 1.91234 25.6267 1.9098 25.0077 2.26351L26 4ZM26 16L25.0077 17.7365C25.6267 18.0902 26.3872 18.0877 27.0039 17.7298C27.6205 17.372 28 16.7129 28 16H26ZM19.9923 9.73649L26.9923 5.73649L25.0077 2.26351L18.0077 6.26351L19.9923 9.73649ZM24 4V16H28V4H24ZM26.9923 14.2635L19.9923 10.2635L18.0077 13.7365L25.0077 17.7365L26.9923 14.2635Z",
    fill: "#F57078",
    mask: "url(#path-2-outside-1_1450_5474)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.591c57d63c2ce263a20e485e5f55137c.svg";
export { ForwardRef as ReactComponent };